import { Injectable, computed, inject, resource } from "@angular/core";
import { Address, ExploredPerson, PersonUpdatePayload } from "@interfaces";
import { ExplorerService } from "../../explorer.service";


@Injectable({ providedIn: 'root' })
export class PersonExplorerService {

	readonly explorer = inject(ExplorerService);

	// track only personId so currentItem updates don't unnecessarily rerun the loader.
	readonly personId = computed(() => this.explorer.nav.currentItem().id);

	person = resource<ExploredPerson, number>({
		params: this.personId,
		loader: async ({ params: personId }) => this.explorer.func.person.get({ personId }),
	});

	reloadData() {
		this.person.reload();
	}

	async updatePersonDetails(values: PersonUpdatePayload) {
		await this.explorer.func.person.updatePersonDetails({ personId: this.personId(), values });
		await this.reloadData();
	}

	async updatePersonAddress(address: Address) {
		await this.explorer.func.person.updatePersonAddress({ personId: this.personId(), address });
		await this.reloadData();
	}

	async addEmail(email: string) {
		const results = await this.explorer.func.person.email.addEmail({ personId: this.personId(), email });
		await this.reloadData();
		return results;
	}

	async setPrimaryEmail(emailId: number) {
		await this.explorer.func.person.email.setPrimaryEmail({ personId: this.personId(), emailId });
		await this.reloadData();
	}

	async deleteEmail(emailId: number) {
		await this.explorer.func.person.email.deleteEmail({ personId: this.personId(), emailId });
		await this.reloadData();
	}

	async addWeblink(webLinkTypeId: number, url: string) {
		await this.explorer.func.person.webLink.addWebLink({ personId: this.personId(), webLinkTypeId, url });
		await this.reloadData();
	}

	async updateWebLink(webLinkId: number, webLinkTypeId: number, url: string, deleted: boolean) {
		await this.explorer.func.person.webLink.updateWebLink({ personId: this.personId(), webLinkId, webLinkTypeId, url, deleted });
		await this.reloadData();
	}
}